module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapa-edicoes"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin m-r-xs"
  }), _vm._v(" Carregando edições...\n  ")]) : (_vm.erro) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_vm._v("\n    Não foi possível carregar o histórico.\n  ")]) : (_vm.historico && _vm.historico.length === 0) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_vm._v("\n    Nenhuma edição de cadastro registrada para esta GRV.\n  ")]) : (_vm.historico) ? _c('div', {
    staticClass: "timeline-wrapper"
  }, _vm._l((_vm.historico), function(entry, idx) {
    return _c('div', {
      key: entry.id,
      staticClass: "tl-entry"
    }, [_c('div', {
      staticClass: "tl-left"
    }, [_c('div', {
      staticClass: "tl-dot"
    }), _vm._v(" "), (idx < _vm.historico.length - 1) ? _c('div', {
      staticClass: "tl-line"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "panel panel-default tl-card"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "tl-meta m-b-xs"
    }, [_c('strong', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "fa fa-user-o m-r-xs"
    }), _vm._v(_vm._s(entry.username) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted m-l-sm"
    }, [_c('i', {
      staticClass: "fa fa-clock-o m-r-xs"
    }), _vm._v(_vm._s(entry.data) + "\n            ")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-condensed table-striped m-n"
    }, [_c('tbody', _vm._l((entry.alteracoes), function(alt) {
      return _c('tr', {
        key: alt.campo
      }, [_c('td', {
        staticClass: "tl-field-nome"
      }, [_vm._v(_vm._s(alt.campo))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "label label-danger tl-val"
      }, [_vm._v(_vm._s(alt.de))])]), _vm._v(" "), _c('td', {
        staticClass: "tl-seta text-muted"
      }, [_vm._v("→")]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "label label-success tl-val"
      }, [_vm._v(_vm._s(alt.para))])])])
    }), 0)])])])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e9c478","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/historico-alteracoes/components/MapaEdicoesGrv.vue
// module id = 2201
// module chunks = 1